import * as React from 'react'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { reverse } from 'named-urls'

import routes from 'bvdash/routes'
import { ThreeDotsMenu } from 'bvdash/ui/tables'
import { ConfirmStatusChange } from 'bvdash/actions/ui'

import { authUser } from 'bvdash/auth/queries'
import { startConversation } from 'bvdash/conversations/queries'
import {
  withProjectIssueClose,
  withProjectIssueReopen,
} from 'bvdash/projects/scenes/ProjectIssues/queries'

function IssueContextMenu(props) {
  const {
    id,
    issueId,
    projectKey,
    managerKey,
    assignedToKey,
    isOpen,
    canEdit,
    history,
    projectIssueReopen,
    projectIssueClose,
    startConversation,
    authUser,
    titles,
  } = props

  return (
    <ConfirmStatusChange titles={titles} type="issue" isOpen={isOpen}>
      {confirm => (
        <ThreeDotsMenu
          actions={[
            {
              label: `Edit ${titles.issue}`,
              onClick: () => {
                return history.push(
                  reverse(routes.project.issueEdit, {
                    projectKey,
                    issueId,
                  })
                )
              },
            },
            {
              label: `Reopen ${titles.issue}`,
              onClick: confirm(() => projectIssueReopen(id)),
              hide: !canEdit || isOpen,
            },
            {
              label: `Close ${titles.issue}`,
              onClick: confirm(() => projectIssueClose(id)),
              hide: !canEdit || !isOpen,
            },
            {
              label: 'Contact Assignee',
              onClick: () => startConversation([assignedToKey]),
              hide: authUser.user && authUser.user.key === assignedToKey,
            },
            {
              label: 'Contact PM',
              onClick: () => startConversation([managerKey]),
              hide: authUser.user && authUser.user.key === managerKey,
            },
          ]}
        />
      )}
    </ConfirmStatusChange>
  )
}

export default compose(
  withRouter,
  authUser,
  withProjectIssueClose,
  withProjectIssueReopen,
  startConversation
)(IssueContextMenu)
